import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button, Card, CardBody, Container } from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import CustomForm from "../../custom/Forms/CustomForm.js";
import SelectInput from "../../custom/components/Select-Input/SelectInput.js";
import TextInput from "../../custom/components/Text-Input/TextInput.js";
import TextAreaInput from "../../custom/components/TextArea-Input/TextAreaInput.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput.js";
import Asterisks from "../../custom/components/Asterisks/Asterisks.js";
import { validate } from "../../custom/validations/Validate.js";
import { getRecords, saveRecords } from "../../services/api.service.js";
import { toast } from "react-toastify";
import { LoaderCreatePage } from "../Loader/Loader.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../Style/loaderOverly.js";
import DatePicker from "../../custom/components/Date-Picker/DatePicker.js";
import { createPageData, basicFormData } from "./MaterialApprovalFile.js";
import BasicPopupModel from "../../custom_components/Components/BasicPopupModel.js";
import Select from "react-select";
import CustomError from "../../custom/components/Errors/CustomError.js";
import formatDateTime from "../../custom/Utils/formatDateTime.js";

const MaterialApprovalFrom = ({ intakeNo, materialId, materialsData }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, headerName, validationType, createEndpoint } =
    createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [loadingSubmit, setLoadingSubmit] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [formErrors, setFormErrors] = useState({});
  // role
  const [techiniciansSelectOptions, setTechiniciansSelectOptions] = useState(
    [],
  );
  const [selectedTechinicians, setSelectedTechinicians] = useState("");
  const [techniciansError, setTechniciansError] = useState("");
  const [popup, setPopup] = useState(false);
  const [action, setAction] = useState("None");
  const [scrapReasonsOptions, setScrapReasonsOptions] = useState([]);
  const [selectedScrapReasons, setSelectedScrapReasons] = useState("");
  const [scrapReasonsError, setScrapReasonsError] = useState("");

  useEffect(() => {
    if (action === "Approve") {
      getTechniciansData();
    } else if (action === "Reject") {
      getScrapReasonsData();
    }
  }, [action]);

  const getScrapReasonsData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "scrap_reason_masters",
        whereCondition: {
          is_active: true,
        },
        schema: initialPayload?.schema,
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: item.reason,
      }));
      setScrapReasonsOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };

  const getTechniciansData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "user_masters",
        whereCondition: {
          is_active: true,
          role_id: 2,
        },
        schema: initialPayload?.schema,
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: `${item.first_name} ${item.last_name}`,
      }));
      setTechiniciansSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "is_repairable" && checked === false) {
      setTechniciansError("");
    }
    setFormErrors((prevErrors) => {
      const fieldError = validate(validationType, { [name]: value });
      return {
        ...prevErrors,
        [name]: fieldError[name] || null,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked === true
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
              ? null
              : value,
      },
    }));
  };

  const handleTechniciansSelect = (options) => {
    const selectedValue = options ? options.value : "";

    setSelectedTechinicians(options);

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        technician_id: selectedValue,
      },
    }));

    setTechniciansError("");
  };

  const handleScrapReasonsSelect = (options) => {
    const selectedValue = options ? options.value : "";

    setSelectedScrapReasons(options);

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        scrap_reason_id: selectedValue,
      },
    }));

    setScrapReasonsError("");
  };

  const handleValidation = () => {
    if (action === "Approve" && !selectedTechinicians?.value) {
      setTechniciansError("Engineer is required");
      return;
    }

    if (action === "Reject" && !selectedScrapReasons?.value) {
      setScrapReasonsError("Scrap Reason is required");
      return;
    }
    setPopup(true);
  };

  // Submit

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingSubmit(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));
      const userId = userDetails?.id;

      const currentDate = new Date();
      let finalPayload;
      let scrapPayload;
      let approvePayload;

      if (action === "Approve") {
        approvePayload = {
          modelName: "material_intakes",
          schema: initialPayload?.schema,
          id: materialId,
          inputData: {
            intake_no: intakeNo,
            is_repairable: true,
            technician_id: selectedTechinicians?.value,
            inspected_by: userId,
            inspected_at: currentDate.toString(),
            received_by: userId,
            inspected_remark: formData.inputData.inspected_remark,
            is_active: formData.inputData.is_active,
            created_by: userId,
            updated_by: userId,
          },
        };
      } else {
        scrapPayload = {
          modelName: "scraps",
          schema: initialPayload?.schema,

          inputData: {
            intake_id: materialId,
            scrap_reason_id: selectedScrapReasons?.value,
            approved_by: userDetails?.id || "",
            approved_at: currentDate.toString(),
            remark: formData.inputData.scrap_remark,
            status: "Pending Approval",
            is_active: true,
          },
        };
      }

      finalPayload = action === "Approve" ? approvePayload : scrapPayload;
      // console.log(finalPayload)
      // return

      const responseData = await saveRecords(finalPayload, createEndpoint);

      // Handle response
      if (responseData && responseData.code === 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`,
        );
        if (action === "Approve") {
          navigate("/job-card-list");
        } else {
          navigate("/scrap-list");
        }
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`,
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingSubmit(false);
      // setPopup(false)
    }
  };

  return (
    <>
      <div className="card p-3">
        <h5 className="mb-3 border border-0">Material Intake Details</h5>

        <div className="container-fluid">
          <div className="card">
            <div className="card-body">
              <Row>
                {/* First Section (Left Side) */}
                <Col md="6" className="border-end border-secondary p-3">
                  <p>
                    <strong>Intake No: </strong>
                    {materialsData?.intake_no || "-"}
                  </p>
                  <p>
                    <strong>GMDS Code: </strong>
                    {materialsData?.material?.gmds_code || "-"}
                  </p>
                  <p>
                    <strong>Item Description: </strong>
                    {materialsData?.material?.descriptions || "-"}
                  </p>
                  <p>
                    <strong>Customer Name: </strong>
                    {materialsData?.customer?.client_name || "-"}
                  </p>
                </Col>

                {/* Second Section (Right Side) */}
                <Col md="6" className="p-3">
                  <p>
                    <strong>Issue Descriptions: </strong>
                    {materialsData?.issue_descriptions || "-"}
                  </p>
                  <p>
                    <strong>Received By: </strong>
                    {materialsData?.received_by_user?.first_name || "-"}{" "}
                    {materialsData?.received_by_user?.last_name || "-"}
                  </p>

                  <p>
                    <strong>Received At: </strong>
                    {!materialsData?.received_date || loadingData
                      ? "-"
                      : formatDateTime(materialsData?.received_date)}
                  </p>
                  {/* <p>
                  <strong>Is Active: </strong>
                  {materialsData?.is_active === true
                    ? "ACTIVE"
                    : "IN-ACTIVE" || "-"}
                </p>
                <p>
                  <strong>Created At: </strong>
                  {!materialsData?.createdAt || loadingData
                    ? "-"
                    : formatDateTime(
                      materialsData?.createdAt
                    )}
                </p>

                <p>
                  <strong>Updated At: </strong>
                  {!materialsData?.updatedAt || loadingData
                    ? "-"
                    : formatDateTime(
                      materialsData?.updatedAt
                    )}
                </p> */}
                </Col>
              </Row>
            </div>
          </div>
        </div>

        {action === "None" && (
          <form>
            <div className="mt-3 d-flex gap-3 flex-wrap">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setAction("Approve");
                }}
              >
                Approve
              </button>
              <button
                type="button"
                onClick={() => {
                  setAction("Reject");
                }}
                className="btn btn-secondary"
              >
                Reject
              </button>
            </div>
          </form>
        )}

        <BasicPopupModel
          isVisible={popup && !loadingData}
          onClose={() => setPopup(false)}
          title={
            action === "Approve"
              ? "Approve Material Approval"
              : "Reject Material Approval"
          }
        ></BasicPopupModel>
        {loadingData && (
          <div style={loaderOverlay}>
            <LoaderCreatePage />
          </div>
        )}
      </div>
      {action !== "None" && (
        <div className="card p-3">
          {action === "Approve" && (
            <form onSubmit={handleSubmit}>
              <div className="mb-2">
                <h5 className="border border-0">Approve Material</h5>
              </div>
              <Row>
                <Col md="6" className="mt-1">
                  <label htmlFor="technicians">
                    Engineers <span className="text-danger">*</span>
                  </label>
                  <Select
                    options={techiniciansSelectOptions}
                    value={selectedTechinicians}
                    onChange={handleTechniciansSelect}
                    placeholder="Select Engineers"
                    classNamePrefix="react-select"
                    className={techniciansError.length ? "input-error" : ""}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: techniciansError.length
                          ? "#d15757"
                          : state.isFocused
                            ? "blue"
                            : "#ccc",
                      }),
                    }}
                  />
                  {techniciansError && <CustomError error={techniciansError} />}
                </Col>
                <Col md="6" className="mt-1">
                  <TextInput
                    label="Remark"
                    name="inspected_remark"
                    value={formData.inputData.inspected_remark}
                    onChange={onInputChange}
                    inputClassName="form-control"
                    labelClassName="form-label"
                  />
                </Col>
              </Row>
              <div className="mt-3 d-flex gap-3 flex-wrap">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleValidation}
                >
                  {action}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setAction("None");
                  }}
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
              </div>
            </form>
          )}

          {action === "Reject" && (
            <form onSubmit={handleSubmit}>
              <div className="mb-2">
                <h5 className="border border-0">Reject Material</h5>
              </div>
              <Row>
                <Col md="6" className="mt-1">
                  <label htmlFor="scrap_reasons">
                    Scrap Reasons <span className="text-danger">*</span>
                  </label>
                  <Select
                    options={scrapReasonsOptions}
                    value={selectedScrapReasons}
                    onChange={handleScrapReasonsSelect}
                    placeholder="Select Scrap Reasons"
                    classNamePrefix="react-select"
                    className={scrapReasonsError.length ? "input-error" : ""}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: scrapReasonsError.length
                          ? "#d15757"
                          : state.isFocused
                            ? "blue"
                            : "#ccc",
                      }),
                    }}
                  />
                  {scrapReasonsError && (
                    <CustomError error={scrapReasonsError} />
                  )}
                </Col>
                <Col md="6" className="mt-1">
                  <TextInput
                    label="Scrap Remark"
                    name="scrap_remark"
                    value={formData.inputData.scrap_remark}
                    onChange={onInputChange}
                    inputClassName="form-control"
                    labelClassName="form-label"
                  />
                </Col>
              </Row>
              <div className="mt-3 d-flex gap-3 flex-wrap">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleValidation}
                >
                  {action}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setAction("None");
                  }}
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      )}

      <BasicPopupModel
        isVisible={popup}
        onClose={() => setPopup(false)}
        title={`Are you sure you want to ${action} this Material Intake!`}
      >
        <div className="mt-3">
          <div className="text-center">
            <span>Intake No: </span> <strong>{intakeNo}</strong>
          </div>
          <div className="mt-3 d-flex gap-3 flex-wrap justify-content-center">
            <button
              type="button"
              className="btn btn-primary"
              onClick={(e) => {
                handleSubmit(e);
                setPopup(false);
              }}
            >
              {action}
            </button>
            <button
              type="button"
              onClick={() => {
                setPopup(false);
              }}
              className="btn btn-secondary"
            >
              Cancel
            </button>
          </div>
        </div>
      </BasicPopupModel>

      {loadingSubmit && (
        <div style={loaderOverlay}>
          <LoaderCreatePage />
        </div>
      )}
    </>
  );
};

export default MaterialApprovalFrom;
